export default __webpack_public_path__ + "static/main-video-mobile-2f3e23294958e872ab6a97f761aee571.webm";